<div class="modal-dialog modal-md mt-0 mb-0" role="document">
    <div class="modal-content">
        <div class="modal-body">
            <button type="button" aria-label="Close" (click)="bsModalRef.hide()" class="btn-close btn-danger float-end"
                data-bs-dismiss="modal" aria-label="Close">
            </button>
            <div class="content">
                <div class="div-title">
                    <span>Informações sobre o Orçamento</span>
                </div>
                <div class="div"></div>
                <div class="info">
                    <span (click)="copiarProtocolo()"><strong>Protocolo:</strong> {{jsonDados.protocolo?jsonDados.protocolo:'Não Informado'}} <i
                            class="fa fa-copy click-to-copy-modal"></i><span class="alertSpanModal"></span></span>
                    <span><strong>Placa:</strong> {{jsonDados.placa?jsonDados.placa:'Não Informado'}}</span>
                    <span><strong>Data Abertura:</strong> {{jsonDados.data_abertura?(jsonDados.data_abertura | date: 'dd/MM/yyyy'):'Não Informado'}}</span>
                    <span><strong>Nome:</strong> {{jsonDados.nome?jsonDados.nome:'Não Informado'}}</span>
                    <span><strong>Atribuição:</strong> {{jsonDados.atribuicao?jsonDados.atribuicao:'Não Informado'}}</span>
                    <span><strong>Responsável:</strong> {{jsonDados.responsavel?jsonDados.responsavel:'Não Informado'}}</span>
                    <span><strong>Cobertura:</strong> {{jsonDados.cobertura?jsonDados.cobertura:'Não Informado'}}</span>
                    <span><strong>Situação:</strong> {{jsonDados.situacao?jsonDados.situacao:'Não Informado'}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
